<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-card-title>Sample</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <b-row>
                <b-col cols="12">
                  <h5><strong>Date Picker</strong></h5>
                  <p>Use to pick a date for a selected time.</p>
                  <b-img
                    src="@/assets/images/pages/calendar-sample-1.png"
                    fluid
                  />
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardText,
    BImg,
  },
}
</script>
